import { ISavingsCalculatorFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import SavingsCalculator from './SavingsCalculator'

const ContentfulSavingsCalculator = withContentful<ISavingsCalculatorFields>(SavingsCalculator, {
  provinceDropdown: (props) => {
    return {
      ...props.fields.provinceDropdown.fields,
      options: props.fields.provinceDropdown.fields.options.map((option) => option.fields),
    }
  },
  deviceValues: (props) => {
    return props.fields.deviceValues.map((value) => ({
      ...value.fields,
    }))
  },
  rewardsValues: (props) => {
    return props.fields.rewardsValues.fields
  },
  step3CTAProps: (props) => props.fields.step3CTAProps?.fields,
})

export default ContentfulSavingsCalculator
